export default __webpack_public_path__ + "898533f409071553e504800ab4cdec01.png";